/**
 * Navigation actions
 * @namespace navigation_actions
 * @category Redux
 * @subcategory Actions
 */
// eslint-disable-next-line
const navigation_actions = {};
//used for the namespace in the documentation

/**
 * Navigation tram action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavTram
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavTram = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_TRAM", payload: value });
  };
};
/**
 * Navigation trolley action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavTrolley
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavTrolley = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_TROLLEY", payload: value });
  };
};
/**
 * Navigation bus action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavBus
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavBus = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_BUS", payload: value });
  };
};
/**
 * Navigation subway action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavSubway
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavSubway = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_SUBWAY_STATIONS", payload: value });
    dispatch({ type: "SET_NAV_SUBWAY_LINES", payload: value });
  };
};
/**
 * Navigation hobo action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavHobo
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavHobo = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_HOBO", payload: value });
  };
};
/**
 * Navigation spark action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavSpark
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavSpark = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_SPARK", payload: value });
  };
};
/**
 * Navigation chargers action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setChargerHobo
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavCharger = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_CHARGER", payload: value });
  };
};
/**
 * Navigation green corridor 1 action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavGreenCorridor1
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavGreenCorridor1 = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_GREEN_CORRIDOR_ONE", payload: value });
  };
};
/**
 * Navigation green corridor 2 action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavGreenCorridor2
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavGreenCorridor2 = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_GREEN_CORRIDOR_TWO", payload: value });
  };
};
/**
 * Navigation green corridor 3 action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavGreenCorridor3
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavGreenCorridor3 = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_GREEN_CORRIDOR_THREE", payload: value });
  };
};
/**
 * Navigation cycleways action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavCycleways
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
export const setNavCycleways = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_CYCLEWAYS", payload: value });
  };
};

//kanachkova

/**
 * Navigation temporary reconstructions action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavReconstructionsTemporary
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
 export const setNavReconstructionsTemporary = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_RECONSTRUCTIONS_TEMPORARY", payload: value });
  };
};

//kanachkova

/**
 * Navigation permanent reconstructions action
 * @category Redux
 * @subcategory Actions
 * @memberof navigation_actions
 * @function setNavReconstructionsPermanent
 * @param {object} value the payload value passed to the reducer
 * @returns Redux dispatch action
 */
 export const setNavReconstructionsPermanent = (value) => {
  return (dispatch, getState) => {
    dispatch({ type: "SET_NAV_RECONSTRUCTIONS_PERMANENT", payload: value });
  };
};